import React from 'react'

const SectionHeader_2 = (props) => {
    const {title, subTitle, text} = props;
    return (
        <>
            <h2 className="section-title fs-3x text-grad-3">{title}</h2>
            {
                subTitle &&
                <p className="text fs-1 text-gray-800 mt-2">{subTitle}</p>
            }
            {
                text &&
                <p className="text my-3 fs-3 mb-10 text-gray-700 px-20"> 
                    {text}
                </p>
            }
        </>
    )
}

export {SectionHeader_2}